import useUserStore from "components/storeUserData";
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    const userData = useUserStore((state) => state.userData);

    if (!userData) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;